import { type ReactNode, type RefObject } from 'react';
import { ChevronLeft, ChevronRightIcon } from '../../../../icons';

/** Left/right scroll arrows for a horizontal carousel (Figma: every horizontal
 *  scroll has these in the section header). Shared by Content + Notable carousels. */
export function CarouselArrows({
  scrollRef,
  step = 240,
}: {
  scrollRef: RefObject<HTMLDivElement | null>;
  step?: number;
}) {
  const by = (delta: number) => scrollRef.current?.scrollBy({ left: delta, behavior: 'smooth' });
  return (
    <div className="flex flex-none items-center gap-2">
      <Arrow ariaLabel="Scroll left" onClick={() => by(-step)}>
        <ChevronLeft size={16} />
      </Arrow>
      <Arrow ariaLabel="Scroll right" onClick={() => by(step)}>
        <ChevronRightIcon size={16} />
      </Arrow>
    </div>
  );
}

function Arrow({
  ariaLabel,
  onClick,
  children,
}: {
  ariaLabel: string;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      className="inline-flex size-8 flex-none items-center justify-center rounded-full border border-[#E5E5E5] bg-white text-[#737373] transition-colors hover:bg-[#F4F4F2]"
    >
      {children}
    </button>
  );
}
